import { PeriodCoreBase } from "./period.core.base"


export class PeriodCore extends PeriodCoreBase {

}